import { PKG_ERROR_TYPES } from '@/components/Packages/errorTypes'

import { PKG_HOTEL_LISTINGS_ERROR_PERSIST_SEARCH_CRITERIA_SETI } from './pkg-session-recovery'

export type FireHotelListingsRerouteImpressionIfFinalParams = {
  /** Prefer `(code) => pclnExperimentation.fireImpression(code)` so `this` is preserved. */
  fireImpression: (experimentCode: string) => void
  redirectSource: string | string[] | undefined
  message: string | string[] | undefined
  /** True when vacationpackages will `router.replace` to `/shop/search` — pkg-search owns the impression then. */
  willHandOffToShopSearch: boolean
}

/**
 * Fires PKG_HOTEL_LISTINGS_ERROR_PERSIST_SEARCH_CRITERIA when this page is the final stop
 * for a hotel-listings error redirect. No SETI state check — relax-ui already gated VARIANT.
 */
export function fireHotelListingsRerouteImpressionIfFinal({
  fireImpression,
  redirectSource,
  message,
  willHandOffToShopSearch,
}: FireHotelListingsRerouteImpressionIfFinalParams): void {
  const isRedirectSourceError = typeof redirectSource === 'string' && redirectSource.toLowerCase() === 'error'
  if (!isRedirectSourceError) {
    return
  }

  if (message !== PKG_ERROR_TYPES.HOTEL_LISTINGS_REROUTE_ERROR) {
    return
  }

  if (willHandOffToShopSearch) {
    return
  }

  fireImpression(PKG_HOTEL_LISTINGS_ERROR_PERSIST_SEARCH_CRITERIA_SETI)
}
